export default __webpack_public_path__ + "static/media/galaxis.f2c54a31.svg";